import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Landing components
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import StatsTicker from './components/StatsTicker/StatsTicker';
import Nosotros from './components/Nosotros/Nosotros';
import Servicios from './components/Servicios/Servicios';
import PlanesDePago from './components/PlanesDePago/PlanesDePago';
import AliadosEstrategicos from './components/AliadosEstrategicos/AliadosEstrategicos';
import Mapa from './components/Mapa/Mapa';
import Footer from './components/Footer/Footer';

// Pages
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import RecuperarPassword from './pages/RecuperarPassword/RecuperarPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad/PoliticaPrivacidad';

import './App.css';

const Landing = () => (
  <div className="App">
    <Navbar />
    <Hero />
    <StatsTicker />
    <Nosotros />
    <Servicios />
    <PlanesDePago />
    <AliadosEstrategicos />
    <Mapa />
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/recuperar-password" element={<RecuperarPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
